// extracted by mini-css-extract-plugin
export var buttonWrapper = "form-module--buttonWrapper--b556d";
export var buttonWrapperLeft = "form-module--buttonWrapperLeft--4a98f";
export var buttonWrapperRight = "form-module--buttonWrapperRight--2e34a";
export var cancelButton = "form-module--cancelButton--cbba7";
export var form = "form-module--form--4a41d";
export var formItem = "form-module--formItem--80b96";
export var formWrapper = "form-module--formWrapper--fcbd1";
export var submitButton = "form-module--submitButton--45611";